import React from 'react';
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import {Divider} from "@mui/material";
import {useTheme} from "@mui/styles";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";

export const TitleUtils = ({num, title, subTitle, topDiv, bottomDiv}) => {
	let theme = useTheme();
	const classes = BaseStyle();
	
	return (
		<React.Fragment>
			{topDiv && <Grid item xs={12}>
				<Divider/>
			</Grid>}
			<Grid item xs={12}>
				<Typography className={classes.heading}><b><span
					style={{fontSize: 26, color: theme.palette.primary.main}}>{num}. </span>{title}</b><br/>
					{subTitle && <span style={{color: theme.palette.text.secondary}}>{subTitle}</span>}
				</Typography>
			</Grid>
			{bottomDiv && <Grid item xs={12}>
				<Divider/>
			</Grid>}
		</React.Fragment>
	);
}
